
export default {
  name: 'OctalToText',
  jsonld() {
    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What is a valid Octal number?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "A valid octal number is expressed in base-8 notation, using digits 0 to 7. It should not contain any other digits, such as 8 or 9."
          }
        },
        {
          "@type": "Question",
          "name": "Can I convert the Text to Octal?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "The answer is yes. Each character in the text is assigned a unique octal representation based on a character encodings scheme like ASCII or Unicode."
          }
        },
        {
          "@type": "Question",
          "name": "Can Octal values represent all characters and symbols?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "No. In most cases, they can represent standard alphanumeric characters and some special symbols. Yet, they may not be able to represent all possible characters and symbols in modern character sets."
          }
        },
        {
          "@type": "Question",
          "name": "How accurate is Octal to Text conversion?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "The accuracy depends on the encoding and the completeness of the character mapping. Using the appropriate encoding ensures accurate conversion."
          }
        },
        {
          "@type": "Question",
          "name": "Is there any limitation when converting Octal to Text?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Some limitations include the inability to represent some characters or symbols outside the range of the character encoding scheme used. Also, if the octal number is not correctly formatted, the conversion may produce unexpected results or errors."
          }
        }
      ]
    };
  },
  data () {
    return {
      data: '',
      form: this.$vform({
        octal_number: null
      })
    }
  },
  methods: {
    OctalToText() {
        this.form.post(`/tool/octal-to-text`, { progress: false }).then(res => {
          this.data = res.data;
        }).catch(e => {
          console.log(e);
        });
    },
    onSample(){
        this.form.octal_number = '150 145 154 154 157';
    },
    onReset(){
        this.form.reset();
        this.data = null;
    }
  }
}
